import { Controller } from "@hotwired/stimulus"
import RequestHelper from "../helpers/request_helper"

// Initializes jQuery DataTables directly rather than going through the shared `datatable`
// controller, so this page renders DataTables' default chrome: default English strings, a real
// search box and length menu, and no chevron pagination reskin. Routing it through the shared
// controller would change how the page actually looks.
export default class extends Controller {
  static get targets() {
    return ["table"];
  }

  static get values() {
    return { source: String };
  }

  connect() {
    this.dataTable = $(this.tableTarget).dataTable({
      processing: true,
      serverSide: true,
      searchDelay: 500,
      order: [[0, "desc"]],
      ajax: { url: this.sourceValue },
      pageLength: 25,
      pagingType: "full_numbers",
      columns: [{ data: "actions" }, { data: "charity" }, { data: "gift_levels" }, { data: "description" }],
    });

    this.bindSearchInput();
  }

  disconnect() {
    if ($.fn.DataTable.isDataTable(this.tableTarget)) {
      $(this.tableTarget).DataTable().destroy();
    }
  }

  // Known gap, long-standing: there is no error branch, so a failed request leaves the button
  // disabled until the page is reloaded. The same `charities_organization` payload key is sent
  // whether the button targets the assign/unassign or the ignore/un-ignore endpoint.
  onRowButtonClick(event) {
    const button = event.currentTarget;

    button.disabled = true;

    const method = (button.dataset.method || "").toLowerCase();
    const options = method === "delete" ? RequestHelper.defaultDeleteOptions() : RequestHelper.defaultPostOptions();
    options.headers = Object.assign({}, options.headers, { "Content-Type": "application/json" });
    options.body = JSON.stringify({
      charities_organization: {
        // `.dataset` never coerces, unlike jQuery's `.data()` - these are numeric ids, so coerce
        // explicitly to keep the JSON payload shape identical to what the server expects.
        charity_id: Number(button.dataset.charityId),
        organization_id: Number(button.dataset.organizationId),
      },
    });

    fetch(button.dataset.url, options).then((response) => {
      if (!response.ok) {
        return;
      }

      response.json().then((data) => this.onRowButtonSuccess(button, data, response.status));
    });
  }

  onRowButtonSuccess(button, data, status) {
    if (data.url.includes("ignore")) {
      if (status === 201) {
        button.classList.add("btn-primary");
        button.textContent = "+";
        button.dataset.method = "delete";
      } else {
        button.classList.remove("btn-primary");
        button.textContent = "-";
        button.dataset.method = "post";
      }
    } else {
      if (status === 201) {
        button.classList.remove("btn-primary");
        button.textContent = "-";
        button.dataset.method = "delete";
      } else {
        button.classList.add("btn-primary");
        button.textContent = "+";
        button.dataset.method = "post";
      }
    }

    button.dataset.url = data.url;
    button.disabled = false;
  }

  // Scoped to this controller's own mount rather than a page-global search-input selector.
  bindSearchInput() {
    $(this.element).
      find(".dataTables_filter input[type='search']").
      off("input.charitiesOrganizations").
      on("input.charitiesOrganizations", (event) => {
        clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(() => {
          $(this.tableTarget).DataTable().search(event.currentTarget.value).draw();
        }, 500);
      });
  }
}
